var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3854_56385)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF2E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3828 17.748L24.7562 13.3747C27.4339 10.697 31.7753 10.697 34.4531 13.3747V13.3747C37.1308 16.0524 37.1308 20.3939 34.4531 23.0716L30.0797 27.445",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4443 30.0781L23.1114 34.411C20.4114 37.1111 16.0337 37.1111 13.3336 34.411V34.411C10.6335 31.7109 10.6335 27.3333 13.3336 24.6332L17.6665 20.3003",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.9393,
    y1: 29.7968,
    x2: 29.7959,
    y2: 17.9402,
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3854_56385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLink);
export default __webpack_public_path__ + "static/media/red-link.374c6c9d70bd62bb47284a68f6ebe628.svg";
export { ForwardRef as ReactComponent };